export enum SortingOrderType {
    ASC = "ASC",
    DESC = "DESC",
}

export interface SortingCriterionDto {
    property: string;
    order?: SortingOrderType;
}

export interface SortingFilterDto {
    sortingCriteria: SortingCriterionDto[];
}

export interface SortableDto {
    sorting?: SortingFilterDto;
}
